var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCertificateUntrusted = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 33"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16 24.014a1.778 1.778 0 1 0 0-3.556 1.778 1.778 0 0 0 0 3.556ZM16 8.014c-.978 0-1.778.8-1.778 1.778v7.11c0 .979.8 1.779 1.778 1.779s1.778-.8 1.778-1.778V9.792c0-.978-.8-1.778-1.778-1.778Z"
})));
export default SvgCertificateUntrusted;